import { Wizard_Mode } from '../../shared/enums'
import { IProtocol, IFile, IField, ILabelInfo, IScanner } from '../../shared/interfaces'

export interface ProtocolWizardReduxState {
    wizardMode: Wizard_Mode,
    protocol: IProtocol,
    docInFields?: IField[],
    docOutFields?: IField[],
    docInternalFields?: IField[],
    stepIndex: number,
    pageScaledWidth: number
    pageScaledHeight: number
    labelInfo: ILabelInfo | undefined,
    valid: boolean,
    touched: boolean,
    selectedPrinterName: string | undefined
    documentFileSource: string;
    attachmentFileSource: string;
    documentScannerFields: IField[];
    attachmentScannerFields: IField[];
    documentScannerLoader: boolean;
    attachmentScannerLoader: boolean;


}

export const SET_INITIAL_STATE = 'SET_INITIAL_STATE'
interface SetInitialStateAction {
    type: typeof SET_INITIAL_STATE
    wizardMode: Wizard_Mode
}
export const SET_DOCUMENT_FILE = 'SET_DOCUMENT_FILE'
interface SetDocumentFileAction {
    type: typeof SET_DOCUMENT_FILE
    documentFile: IFile | undefined
}
export const SET_ATTACHMENTS = 'SET_ATTACHMENTS'
interface SetAttachmentsAction {
    type: typeof SET_ATTACHMENTS
    attachmentsFile: IFile[]
}
export const ADD_ATTACHMENT = 'ADD_ATTACHMENT'
interface AddAttachmentAction {
    type: typeof ADD_ATTACHMENT
    attachmentFile: IFile
}
export const UPDATE_ATTACHMENT = 'UPDATE_ATTACHMENT'
interface UpdateAttachmentAction {
    type: typeof UPDATE_ATTACHMENT
    attachmentFile: IFile
}

export const SET_PROTOCOL = 'SET_PROTOCOL'
interface SetProtocolAction {
    type: typeof SET_PROTOCOL
    protocol: IProtocol
}

export const SET_DOCUMENT_SCANNER_LOADER = 'SET_DOCUMENT_SCANNER_LOADER'
interface SetDocumentScannerLoaderAction {
    type: typeof SET_DOCUMENT_SCANNER_LOADER
    documentScannerLoader: boolean
}

export const SET_ATTACHMENT_SCANNER_LOADER = 'SET_ATTACHMENT_SCANNER_LOADER'
interface SetAttachmentScannerLoaderAction {
    type: typeof SET_ATTACHMENT_SCANNER_LOADER
    attachmentScannerLoader: boolean
}

export const SET_SELECTED_PRINTER_NAME = 'SET_SELECTED_PRINTER_NAME'
interface SetSelectedPrinterName {
    type: typeof SET_SELECTED_PRINTER_NAME
    selectedPrinterName: string 
}

export const UPDATE_PROTOCOL_WIZARD_STATE = 'UPDATE_PROTOCOL_WIZARD_STATE'
interface UpdateCreateProtocolStateAction {
    type: typeof UPDATE_PROTOCOL_WIZARD_STATE
    payload: Partial<ProtocolWizardReduxState>
}

export const SET_PROTOCOL_WIZARD_TOUCHED = 'SET_PROTOCOL_WIZARD_TOUCHED'
interface SetProtocolWizardTouchedAction {
    type: typeof SET_PROTOCOL_WIZARD_TOUCHED
}

export const SET_STEP_INDEX = 'SET_STEP_INDEX'
interface SetStepIndexAction {
    type: typeof SET_STEP_INDEX
    stepIndex: number
}

export const NEXT_STEP_INDEX = 'NEXT_STEP_INDEX'
interface NextStepIndexAction {
    type: typeof NEXT_STEP_INDEX
}

export const PREVIOUS_STEP_INDEX = 'PREVIOUS_STEP_INDEX'
interface PreviousStepIndexAction {
    type: typeof PREVIOUS_STEP_INDEX
}

export const LABEL_DIRECTION_TOGGLE = 'LABEL_DIRECTION_TOGGLE'
interface LabelDirectionToggleAction {
    type: typeof LABEL_DIRECTION_TOGGLE
}
export type ProtocolWizardActionTypes = SetInitialStateAction | SetDocumentFileAction | SetAttachmentsAction | AddAttachmentAction | UpdateAttachmentAction | SetProtocolAction | SetSelectedPrinterName
    | UpdateCreateProtocolStateAction | SetProtocolWizardTouchedAction | SetStepIndexAction | NextStepIndexAction | PreviousStepIndexAction | LabelDirectionToggleAction 
    | SetDocumentScannerLoaderAction | SetAttachmentScannerLoaderAction